import { render, staticRenderFns } from "./StockSlipProduct.vue?vue&type=template&id=356bf392&scoped=true"
import script from "./StockSlipProduct.vue?vue&type=script&lang=js"
export * from "./StockSlipProduct.vue?vue&type=script&lang=js"
import style0 from "./StockSlipProduct.vue?vue&type=style&index=0&id=356bf392&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356bf392",
  null
  
)

export default component.exports